import React from 'react';
import PropTypes from 'prop-types';

const Cell = ({ cell: { value: initialValue } }) => {
  if (Array.isArray(initialValue)) {
    return <div>{initialValue ? initialValue.map((team) => team.name).join(', ') : ''}</div>;
  }
  return <div>{initialValue}</div>;
};

Cell.propTypes = {
  cell: PropTypes.any,
};

export default Cell;
